// src/components/Subpage.jsx
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import themeColors from "../themeColors";

/**
 * Generic layout wrapper for every secondary page.
 * ‑ keeps the header fixed
 * ‑ adds top‑padding so the title never hides behind the header
 * ‑ centres title + intro text
 */
export default function Subpage({ title, content, relatedLinks, children }) {
  return (
    <div style={{ backgroundColor: themeColors.lightGray }}>
      <Header />

      {/* MAIN CONTENT */}
      <main className="pt-28 px-6 md:px-10 2xl:px-0 max-w-7xl mx-auto">
        {/* Page title */}
        <h1
          className="text-3xl md:text-5xl font-bold mb-6 text-center"
          style={{ color: themeColors.primaryText }}
        >
          {title}
        </h1>

        {/* Intro / blurb */}
        {content && (
          <p
            className="text-lg mb-12 text-center leading-relaxed"
            style={{ color: themeColors.secondaryText }}
          >
            {content}
          </p>
        )}

        {/* Related links */}
        {relatedLinks?.length > 0 && (
          <section className="mb-16">
            <h3 className="text-3xl font-semibold mb-4">Related Content</h3>
            <ul className="space-y-2">
              {relatedLinks.map((l, i) => (
                <li key={i}>
                  <a
                    href={l.href}
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    {l.title}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        )}

        {/* Dynamic children (e.g. news cards or full post) */}
        {children}
      </main>

      <Footer />
    </div>
  );
}
